import React, { useState } from 'react'
import { Query } from 'react-apollo'
import _ from 'lodash'
import ReactTable from 'react-table'
import {
  Div, H3, Loading, P, DynamicButtonLink,
} from 'konsys-ui'
import config from './config'
import { theme } from '../../../styles/_variables'
import { GET_CLIENTS } from '../../../constants/graphql/query'
import './style-css.css'
import { Wrapper } from '../../../components/client-components'
import PERMISSION from '../../../constants/permissions'

const { color } = theme

const Index = () => (
  <Div display='flex' flexDirection='column'>
    <Div display='flex' flexDirection='row' justifyContent='space-between' alignItems='center'>
      <H3 bold color={color.primaryColor} margin='32px 0'>สมุดรายชื่อผู้จ้าง</H3>
      <DynamicButtonLink link='/client/add' condition={_.includes(window.perms, PERMISSION.CREATE_CLIENT)} props={{ text: 'เพิ่มลูกค้าใหม่' }}/>
      {/* <Link to='/client/add'><Button text='Create' disabled={!_.includes(window.perms, PERMISSION.CREATE_CLIENT)}/></Link> */}
    </Div>
    <List />
  </Div>
)

export const List = () => {
  const [current, setCurrent] = useState(0)
  const [sorted, setSorted] = useState([{ id: 'id', desc: false }])
  const [filtered, setFiltered] = useState([])

  return (
    <Wrapper overflow padding='0 0 40px 0'>
      <Query
        query={GET_CLIENTS}
        fetchPolicy='cache-and-network'
        variables={{
          limit: 5,
          offset: current * 5,
          orderBy: sorted[0].desc ? 'DESC' : 'ASC',
          orderField: sorted[0].id,
          ...filtered,
        }}
      >{({ data, loading, error }) => {
        if (loading && _.isEmpty(data)) return <Loading center='true' />
        if (error) return <P>เกิดข้อผิดพลาด</P>

        return (
          <Div margin='auto'>
            <ReactTable
              className='table'
              data={data.getCustomerLists.lists} // *
              resizable={false}
              columns={config.columns} // *
              minRows={5}
              manual
              // defaultPageSize={10}
              showPageSizeOptions={false}
              getTdProps={() => ({ disabled: true })} // *
              getTrProps={(state, rowInfo) => { // *
                if (rowInfo) {
                  return {
                    style: {
                      padding: '8px 0',
                      backgroundColor: '#ffffff',
                      borderLeft: `3px solid ${color.primaryColor}`,
                    },
                  }
                } return {}
              }}
              previousText='ก่อนหน้า'
              nextText='ถัดไป'
              pageText='หน้า'
              ofText='จาก'
              noDataText='ไม่พบข้อมูล'
              page={current}
              pages={Math.ceil(data.getCustomerLists.totalFilter / 5)}
              onPageChange={page => setCurrent(page)}
              onFilteredChange={async (newFiltered) => {
                const newOjb = {}
                await newFiltered.forEach((v) => {
                  if (v.id === 'TypeOfCharge.id') Object.assign(newOjb, { typeOfChargeId: v.value })
                  else Object.assign(newOjb, { [v.id]: v.value })
                })
                setCurrent(0)
                setFiltered(newOjb)
              }}
              onSortedChange={async (newSorted) => {
                setSorted(newSorted)
                setCurrent(0)
              }}
            />
            {
              loading && <Div margin='32px 0 0'><Loading center='true' /></Div>
            }
          </Div>
        )
      }}
      </Query>
    </Wrapper>
  )
}

export default Index
